export const getWeatherDescription = (code) => {
    const weatherCodes = {
        0: 'clear sky',
        1: 'mainly clear',
        2: 'partly cloudy',
        3: 'overcast',
        45: 'foggy',
        48: 'depositing rime fog',
        51: 'light drizzle',
        53: 'moderate drizzle',
        55: 'dense drizzle',
        56: 'light freezing drizzle',
        57: 'dense freezing drizzle',
        61: 'slight rain',
        63: 'moderate rain',
        65: 'heavy rain',
        66: 'light freezing rain',
        67: 'heavy freezing rain',
        71: 'slight snow',
        73: 'moderate snow',
        75: 'heavy snow',
        77: 'snow grains',
        80: 'slight rain showers',
        81: 'moderate rain showers',
        82: 'violent rain showers',
        85: 'slight snow showers',
        86: 'heavy snow showers',
        95: 'thunderstorm',
        96: 'thunderstorm with slight hail',
        99: 'thunderstorm with heavy hail'
    };

    return weatherCodes[code] || 'unknown';
};

export const getWeatherIcon = (code, isDay = true) => {
    const iconMap = {
        0: isDay ? '01d' : '01n',      // clear sky
        1: isDay ? '01d' : '01n',      // mainly clear
        2: isDay ? '02d' : '02n',      // partly cloudy
        3: isDay ? '03d' : '03n',      // overcast
        45: isDay ? '50d' : '50n',     // fog
        48: isDay ? '50d' : '50n',     // depositing rime fog
        51: '09d',                      // light drizzle
        53: '09d',                      // moderate drizzle
        55: '09d',                      // dense drizzle
        56: '09d',                      // light freezing drizzle
        57: '09d',                      // dense freezing drizzle
        61: isDay ? '10d' : '10n',      // slight rain
        63: isDay ? '10d' : '10n',      // moderate rain
        65: isDay ? '10d' : '10n',      // heavy rain
        66: '13d',                      // light freezing rain
        67: '13d',                      // heavy freezing rain
        71: '13d',                      // slight snow
        73: '13d',                      // moderate snow
        75: '13d',                      // heavy snow
        77: '13d',                      // snow grains
        80: '09d',                      // slight rain showers
        81: '09d',                      // moderate rain showers
        82: '09d',                      // violent rain showers
        85: '13d',                      // slight snow showers
        86: '13d',                      // heavy snow showers
        95: '11d',                      // thunderstorm
        96: '11d',                      // thunderstorm with slight hail
        99: '11d'                       // thunderstorm with heavy hail
    };

    return iconMap[code] || '01d';
};

export const fetchWeather = async () => {
    try {
        const response = await fetch(
            `https://api.open-meteo.com/v1/forecast?latitude=37.3594535374343&longitude=-122.06699114049242&hourly=temperature_2m,precipitation_probability,rain,weather_code,is_day&models=best_match&timezone=America%2FLos_Angeles&wind_speed_unit=mph&temperature_unit=fahrenheit&precipitation_unit=inch`
            // link for changes https://open-meteo.com/en/docs?latitude=37.3594535374343&longitude=-122.06699114049242&timezone=America%2FLos_Angeles&temperature_unit=fahrenheit&wind_speed_unit=mph&precipitation_unit=inch&hourly=temperature_2m,precipitation_probability,rain,weather_code&models=best_match&bounding_box=-90,-180,90,180#api_response
        );
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching weather:', error);
        return null;
    }
};
